module.exports = function() {
  return new Worker(__webpack_public_path__ + "fb948aa14e3c928f05a5.worker.js");
};